import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import Modules from '@/common/modules';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from './store-config';
import {useMemo} from 'react';
import LoadingUtil from '@/util/loading-util';

interface GlobalState {
    isLoading: boolean;
    reload: number;
}

const initialState: GlobalState = {
    isLoading: false,
    reload: 0,
};

const slice = createSlice({
    name: Modules.GLOBAL,
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        reload: (state) => {
            state.reload = state.reload + 1;
        },
    },
});

export const useGlobalState = () => {
    return useSelector((state: RootState) => state.global) as GlobalState;
};

export const useGlobalAction = () => {
    const dispatch = useDispatch();
    return useMemo(
        () => ({
            setLoading: (loading: boolean) => dispatch(slice.actions.setLoading(loading)),
            reload: () => dispatch(slice.actions.reload()),
        }),
        [dispatch],
    );
};

export const useGlobalLoader = () => {
    const {setLoading} = useGlobalAction();
    LoadingUtil.setShowLoadingCallback(setLoading);
    return null;
};

export default slice.reducer;
